import { useEffect, useState } from 'react';
import { Service } from '../api-objects/Service';
import { Review } from '../api-objects/Review';

const ReviewsService = () => {
  const [result, setResult] = useState<Service<Review[]>>({
    status: 'loading'
  });

  useEffect(() => {
    fetch('/api/reviews.json')
      .then(response => response.json())
      .then(response => setResult({ status: 'loaded', payload: response }))
      .catch(error => setResult({ status: 'error', error }));
  }, []);

  return result;
};

export default ReviewsService;